import type { IIpInfo, IZipInfo } from '~/interfaces';
import { alwaysJsonParser } from '~/util/fetch';

export const getZipInfo = async (PostalCode: string): Promise<IZipInfo> => {
  return fetch(`${REPLACE_GEO_ZIP}?PostalCode=${PostalCode}`)
    .then((response: Response) => response.json())
    .catch(() => {
      return {
        errors: {
          zipCode: ['Invalid Zip code'],
        },
      };
    });
};

export const getIpInfo = (): Promise<IIpInfo> => {
  return fetch(REPLACE_GEO_IP)
    .then(alwaysJsonParser<IIpInfo>)
    .catch(() => ({}) as IIpInfo);
};
